const allFormatter = new Intl.ListFormat('en-uk', {
    style: 'long',
    type: 'conjunction',
});

const oneOfFormatter = new Intl.ListFormat('en-uk', {
    style: 'long',
    type: 'disjunction',
});

const mixedFormatter = (items: Array<string>): string => {
    if (items.length === 0) return '';
    if (items.length === 1) return items[0];
    if (items.length === 2) return `${items[0]} and/or ${items[1]}`;
    return `${items.slice(0, -1).join(', ')} and/or ${items[items.length - 1]}`;
};

export { allFormatter, mixedFormatter, oneOfFormatter };
